import LoadingButton from '@mui/lab/LoadingButton'

import withStyles from '@mui/styles/withStyles'

const ButtonSecondary = withStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #C6C6C6',
    borderRadius: '8px',
    width: '148px',
    minHeight: '36px',
    background: 'white',
    color: '#1F1F1F',

    '&:hover': {
      background: 'lightgray'
    },

    '&:disabled': {
      color: 'lightgray !important',
      opacity: '0.5'
    }
  },

  text: {
    fontSize: theme.size.base,
    textTransform: 'none'
  }
}))(LoadingButton)

export default ButtonSecondary
